import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Gift } from 'lucide-react';

export default function AdminReferrals() {
  const [refs, setRefs] = useState([]);
  useEffect(() => { api.get('/referrals/admin').then(r => setRefs(r.data)); }, []);

  const pending = refs.filter(r => r.status === 'pending').length;
  const converted = refs.filter(r => r.status === 'converted' || r.status === 'completed').length;

  return (
    <div className="space-y-6" data-testid="admin-referrals">
      <div>
        <div className="label-mini text-[var(--c-green-ink)]">Growth</div>
        <h1 className="font-display font-black text-4xl mt-1">Referrals</h1>
        <p className="text-sm text-muted-foreground mt-1">Referrer gets 20% off next renewal · Friend gets 10% off first membership</p>
      </div>

      <div className="grid grid-cols-3 gap-3">
        <Stat label="Total" value={refs.length} color="#00C8FF" />
        <Stat label="Pending" value={pending} color="#FFB800" />
        <Stat label="Converted" value={converted} color='#65A30D' />
      </div>

      <div className="regen-card-elevated overflow-hidden">
        <div className="grid grid-cols-12 px-5 py-3 label-mini border-b border-[var(--c-hair)]">
          <div className="col-span-3">Referrer</div>
          <div className="col-span-3">Referred Email</div>
          <div className="col-span-2">Code</div>
          <div className="col-span-2">Status</div>
          <div className="col-span-2">Rewards</div>
        </div>
        {refs.map(r => (
          <div key={r.id} className="grid grid-cols-12 px-5 py-3 items-center border-b border-[var(--c-hair)] last:border-0" data-testid={`referral-row-${r.id}`}>
            <div className="col-span-3 text-sm truncate">{r.referrer_email}</div>
            <div className="col-span-3 text-sm text-muted-foreground truncate">{r.referred_email}</div>
            <div className="col-span-2 text-xs font-mono text-muted-foreground">{r.code || '—'}</div>
            <div className="col-span-2"><span className="pill bg-[var(--c-film)]">{r.status}</span></div>
            <div className="col-span-2 text-xs">
              <div className="text-[var(--c-green-ink)]">{r.referrer_reward || r.reward}</div>
              {r.friend_reward && <div className="text-[#00C8FF]">{r.friend_reward}</div>}
            </div>
          </div>
        ))}
        {refs.length === 0 && <div className="p-10 text-center text-muted-foreground"><Gift className="w-6 h-6 mx-auto mb-2 opacity-30" />No referrals yet.</div>}
      </div>
    </div>
  );
}

function Stat({ label, value, color }) {
  return (
    <div className="regen-card-elevated p-4" data-testid={`referral-stat-${label.toLowerCase()}`}>
      <div className="label-mini">{label}</div>
      <div className="font-mono text-3xl mt-1" style={{ color }}>{value}</div>
    </div>
  );
}
